export default "__VITE_ASSET__CvBYPktA__"